"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  sentenceLength: {
    recommendedWordCount: 25
  }
};